module.exports = __webpack_public_path__ + "static/media/UneteFormacionContinuaMobile.453c3cb1.svg";